module.exports = __webpack_public_path__ + "static/img/format_banner.323abd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/onlinePreview/format_banner.png
// module id = CaT9
// module chunks = 2